var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearchCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8633 22.5H7.91015C6.45609 22.5 5.27343 21.3173 5.27343 19.8633V7.91015C5.27343 6.45609 6.45609 5.27343 7.91015 5.27343H19.8633C21.3173 5.27343 22.5 6.45609 22.5 7.91015V19.8633C22.5 21.3173 21.3173 22.5 19.8633 22.5ZM7.91015 7.03125C7.42552 7.03125 7.03125 7.42552 7.03125 7.91015V19.8633C7.03125 20.3479 7.42552 20.7422 7.91015 20.7422H19.8633C20.3479 20.7422 20.7422 20.3479 20.7422 19.8633V7.91015C20.7422 7.42552 20.3479 7.03125 19.8633 7.03125H7.91015ZM3.51562 15.4687H2.63672C2.15209 15.4687 1.75781 15.0745 1.75781 14.5898V2.63672C1.75781 2.15209 2.15209 1.75781 2.63672 1.75781H14.5898C15.0745 1.75781 15.4687 2.15209 15.4687 2.63672V3.47168H17.2266V2.63672C17.2266 1.18266 16.0439 0 14.5898 0H2.63672C1.18266 0 0 1.18266 0 2.63672V14.5898C0 16.0439 1.18266 17.2266 2.63672 17.2266H3.51562V15.4687Z",
    fill: "#1D1E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchCopyIcon);
export default __webpack_public_path__ + "static/media/research-copy-icon.c8b7b9c412f4689b5c5fa6896558a1fd.svg";
export { ForwardRef as ReactComponent };